import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function ApproveUserPage() {
  const params = new URLSearchParams(window.location.search);
  const token  = params.get('token');
  const action = window.location.pathname.includes('reject') ? 'reject' : 'approve';

  const [status, setStatus] = useState('loading'); // loading | success | error | already_done
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('Missing approval token.'); return; }

    const endpoint = action === 'approve'
      ? `${API_URL}/api/admin/approve-user?token=${token}`
      : `${API_URL}/api/admin/reject-user?token=${token}`;

    fetch(endpoint)
      .then(async res => {
        const text = await res.text();
        if (res.ok) {
          setStatus('success');
          setMessage(text);
        } else {
          setStatus('error');
          setMessage(text || 'Something went wrong.');
        }
      })
      .catch(() => { setStatus('error'); setMessage('Could not reach the server. Please try again.'); });
  }, [token, action]);

  const isApprove = action === 'approve';

  const styles = {
    page:    { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', fontFamily: 'sans-serif' },
    card:    { maxWidth: 420, width: '100%', textAlign: 'center', padding: '48px 32px', background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
    icon:    { fontSize: 52, marginBottom: 16 },
    heading: { margin: '0 0 12px', fontSize: 22, color: status === 'error' ? '#dc2626' : isApprove ? '#16a34a' : '#0f172a' },
    sub:     { color: '#64748b', fontSize: 14, lineHeight: 1.6 },
    spinner: { width: 40, height: 40, border: '3px solid #e2e8f0', borderTop: '3px solid #0f172a', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 20px' },
  };

  return (
    <div style={styles.page}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={styles.card}>
        {status === 'loading' && (
          <>
            <div style={styles.spinner} />
            <p style={styles.sub}>{isApprove ? 'Approving' : 'Rejecting'} access…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={styles.icon}>{isApprove ? '✅' : '🚫'}</div>
            <h2 style={styles.heading}>{isApprove ? 'Access Approved' : 'Access Rejected'}</h2>
            <p style={styles.sub}>
              {isApprove
                ? 'The user has been approved and will receive a confirmation email.'
                : 'The user\'s access request has been rejected.'}
            </p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={styles.icon}>⚠️</div>
            <h2 style={{ ...styles.heading, color: '#dc2626' }}>Something went wrong</h2>
            <p style={styles.sub}>{message}</p>
          </>
        )}
      </div>
    </div>
  );
}
